/**
 * 菜单 menu
 * 侧边栏 sidebar
 * 页签 tab
 * 三者同步
 */

// 核心系统下的菜单
export const SIDEBAR_TYPE = {
    // 管理
    USER: "user", //用户
    FILE: "file", // 文件

    // 公共库
    MATERIAL: "material", // 材料
    SECTION: "section", // 截面

    // 专业通用
    POSITION: "position", // 定位
    
    // 几何
    BLOCK: "block", // 块


    MODEL: "model", // 模型



    SYSTEM_MATERIAL: 'system-lib-material', // 系统材料库
    SYSTEM_SECTION: 'system-lib-section', // 系统截面库
    SYSTEM_DEVICE: 'system-lib-device', // 系统设备库
    SYSTEM_PARAM: "system-lib-param", // 参数库

}
// 核心系统下的小工具
export const TOOL_TYPE = {
    // 专业通用
    FAST_GEN_AXIS_NET: "fast-gen-axis-net", // 快速生成轴网

    // 几何
    BLOCK: "block", // 块

    
    UCS: "ucs", //坐标系
}

/**
 * 菜单 menu
 * 侧边栏 sidebar
 * 页签 tab
 * 三者同步
 */
export const STRUCTURE_SIDEBAR_TYPE = {
    COMPONENT_LIB: "structure-component-lib", // 构件库
    COMPONENT_PARAM: "structur-component-param", // 参数
}

export const STRUCTURE_TOOL_TYPE = {
    COMPONENT_ARRANGE: "structure-component-arrange", // 构件布置
    COMPONENT_MATERIAL_MODIFY: "structure-component-material-modify", // 构件材料修改
    COMPONENT_SECTION_MODIFY: "structure-component-section-modify", // 构建材料修改
}
